import { PERMISSIONS } from "@/constants/permissions";

import { DASHBOARD_ROLES, type DashboardRole } from "../types/dashboard-role.types";

/** Sales agents: My Calls, My appointments, My KPIs only. */
const SALES_AGENT_BASE = [PERMISSIONS.CALL_READ_CALLS, PERMISSIONS.CALL_CALENDAR_READ, PERMISSIONS.CALL_KPIS_READ];

/** Sales team lead: same as sales agent, plus member pickers, team performance, and calendar capacities. */
const SALES_TEAM_LEAD_BASE = [
    ...SALES_AGENT_BASE,
    PERMISSIONS.CALL_CALLS_SELECT_MEMBER,
    PERMISSIONS.CALL_APPOINTMENTS_SELECT_MEMBER,
    PERMISSIONS.CALL_KPIS_SELECT_MEMBER,
    PERMISSIONS.CALL_DASHBOARD_AGENT_PERFORMANCE,
    PERMISSIONS.CALL_CALL_EVALUATION,
    PERMISSIONS.CALL_CALENDAR_CAPACITIES,
];

const SETTING_AGENT_BASE = [
    PERMISSIONS.CALL_READ_CALLS,
    PERMISSIONS.CALL_DIALER,
    PERMISSIONS.CALL_SETTING_LISTS,
    PERMISSIONS.CALL_KPIS_READ,
    PERMISSIONS.CALL_CALENDAR_READ,
    PERMISSIONS.CALL_SETTING_PRIORITY_COUNTS,
    PERMISSIONS.CALL_CALENDAR_CAPACITIES,
];

/** Setting team lead: same as setting agent, plus priority leads, call evaluation and reachability. */
const SETTING_TEAM_LEAD_BASE = [
    ...SETTING_AGENT_BASE,
    PERMISSIONS.CALL_SETTING_PRIORITY_READ_LEADS,
    PERMISSIONS.CALL_CALL_EVALUATION,
    PERMISSIONS.CALL_REACHABILITY_ANALYSIS,
];

const TEAM_LEAD_BASE = [
    PERMISSIONS.CALL_READ_CALLS,
    PERMISSIONS.CALL_DIALER,
    PERMISSIONS.CALL_SETTING_LISTS,
    PERMISSIONS.CALL_KPIS_READ,
    PERMISSIONS.CALL_CALENDAR_READ,
    PERMISSIONS.CALL_SVC_TEAM_LEAD_BASE,
    PERMISSIONS.CALL_CALLS_GLOBAL_SEARCH,
    PERMISSIONS.CALL_CALLS_SELECT_MEMBER,
    PERMISSIONS.CALL_KPIS_SELECT_MEMBER,
    PERMISSIONS.CALL_APPOINTMENTS_SELECT_MEMBER,
    PERMISSIONS.CALL_CALENDAR_CAPACITIES,
    PERMISSIONS.CALL_CALENDAR_BOOKING_READ,
    PERMISSIONS.CALL_CALENDAR_BOOKING_MANAGE,
    PERMISSIONS.CALL_EVENT_TYPE_READ,
];

/** Shared leadership base for Controlling (not used by sales team lead or CSO presets). */
const SALES_LEADERSHIP_BASE = [
    ...TEAM_LEAD_BASE,
    PERMISSIONS.CALL_SCRIPTS_READ,
    PERMISSIONS.CALL_CALENDAR_BOOKING_READ_ME,
];

const CONTROLLING_BASE = [
    ...SALES_LEADERSHIP_BASE,
    PERMISSIONS.CALL_DASHBOARD_AGENT_PERFORMANCE,
    PERMISSIONS.CALL_REPORTS_PRP_ADMIN,
    PERMISSIONS.CALL_REPORTS_SALES_ADMIN,
    PERMISSIONS.CALL_DATA_EXPORT_DOWNLOAD,
];

/** CSO / CMO: Home (Agent Performance), Calls, KPIs, and Reports. */
const CSO_BASE = [
    PERMISSIONS.CALL_SVC_TEAM_LEAD_BASE,
    PERMISSIONS.CALL_READ_CALLS,
    PERMISSIONS.CALL_CALLS_SELECT_MEMBER,
    PERMISSIONS.CALL_CALLS_GLOBAL_SEARCH,
    PERMISSIONS.CALL_KPIS_READ,
    PERMISSIONS.CALL_KPIS_SELECT_MEMBER,
    PERMISSIONS.CALL_REPORTS_SALES_ADMIN,
    PERMISSIONS.CALL_DASHBOARD_AGENT_PERFORMANCE,
];

export const ROLE_PERMISSION_PRESETS: Record<DashboardRole, string[]> = {
    [DASHBOARD_ROLES.SALES_AGENT]: SALES_AGENT_BASE,
    [DASHBOARD_ROLES.SETTING_AGENT]: SETTING_AGENT_BASE,
    [DASHBOARD_ROLES.SALES_TEAM_LEAD]: SALES_TEAM_LEAD_BASE,
    [DASHBOARD_ROLES.SETTING_TEAM_LEAD]: SETTING_TEAM_LEAD_BASE,
    [DASHBOARD_ROLES.CSO]: CSO_BASE,
    [DASHBOARD_ROLES.CMO]: CSO_BASE,
    [DASHBOARD_ROLES.CONTROLLING]: CONTROLLING_BASE,
    [DASHBOARD_ROLES.DEVELOPER]: Object.values(PERMISSIONS),
};

export const PREVIEWABLE_PERMISSIONS = (Object.entries(PERMISSIONS) as [string, string][]).map(([name, code]) => ({
    name,
    code,
}));
